@if (navigating()) {
  <mat-progress-bar mode="indeterminate" class="route-progress" aria-label="Loading page" />
}
@if (showShell()) {
  <app-layout moduleLabel="Consignor Portal" [sections]="sections" logoutRoute="/login">
    <router-outlet />
  </app-layout>
} @else {
  <router-outlet />
}
